/*
 * Helpers.ts
 * Description: This file contains the functions that are used im multiple views.
 */

// Importing Axios for HTTP requests
import Axios from 'axios';
// Importing variables
import {APIURL} from '@/ts/variables';
// Importing functions
import {getMunicipalities} from '@/ts/ekatte/get-municipalities';
import {getTowns} from '@/ts/ekatte/get-towns';

/**
 * Convert an object to FormData
 *
 * @return {Object} FormData - search results
 * @param {Object} object - query text
 */
export function getFormData(object: any) {
    const formData = new FormData();
    Object.keys(object).forEach((key) => formData.append(key, object[key]));
    return formData;
}

/**
 * Refresh JSON web token
 *
 * @return {Object} Promise - whether the refresh was successful
 */
export function refreshToken() {
    const jwt = localStorage.getItem('jwt');
    // Creating a new instance of Promise to make JavaScript work synchronous
    return new Promise( (resolve, reject) => {
        // Creating an HTTP request to refresh jwt token
        Axios({
            url: APIURL + 'auth/refresh',
            method: 'post',
            headers: {
                Authorization: 'Bearer ' + jwt,
            },
            data: {},
        }).then((response) => {
            // Updating the new value of the token
            localStorage.setItem('jwt', response.data.data.access_token);
            // Construct a new expiration date
            const date = new Date(new Date().getTime() + (1000 * response.data.data.expires_in));
            localStorage.setItem('expireDate', String(date));
            resolve(true);
        }).catch(() => {
            // Removing 'jwt' and 'expireDate' from local memory if user is not logged.
            localStorage.removeItem('jwt');
            localStorage.removeItem('expireDate');
            reject(false);
        });
    });
}

/**
 * Checking if the session is expired
 *
 * @return {Boolean} - whether session is still active
 */
export function checkSession() {
    const jwt = localStorage.getItem('jwt');
    const expireDate = localStorage.getItem('expireDate');
    // Checking if a user has 'jwt' and 'expireDate' stored in local memory.
    if (jwt === null) { return false; }
    if (expireDate === null) { return false; }
    if ((new Date(expireDate)).getTime() < (new Date()).getTime()) {
        refreshToken().then(() => {
            return true;
        }).catch(() => {
            return false;
        });
    }
    return true;
}

/**
 * Looks up user IP address
 *
 * @return {Object} Promise - user city
 */
export function IPLookUp() {
    return new Promise( (resolve, reject) => {
        Axios({
            url: APIURL + 'location',
            method: 'get',
        }).then((response) => {
            resolve(response.data);
        }).catch((error) => {
            reject(error);
        });
    });
}

/**
 * Getting the last month
 *
 * @return {String} month - last month
 */
export function getDateYear() {
    const monthNames = ['Януари', 'Февруари', 'Март', 'Април', 'Май', 'Юни',
        'Юли', 'Август', 'Септември', 'Октомври', 'Ноември', 'Декември',
    ];
    const date = new Date();
    return monthNames[date.getMonth() - 1 === -1 ? 11 : date.getMonth() - 1] + ' ' + date.getFullYear();
}

/**
 * Checking if user has permission to access a page
 *
 * @return {Boolean} - whether user has permission
 * @param {String} name - permission that is going to be checked
 */
export function checkPermission(name: string) {
    if (localStorage.getItem('permissions') === null) {
        return false;
    }
    // @ts-ignore
    return localStorage.getItem('permissions').includes(name);
}

/**
 *
 * Reformatting dates
 *
 * @param date
 */
export function reformatDate(date: string) {
    const dArr = date.slice(0, 10).split('-');  // ex input "2010-01-18"
    return dArr[2] + '.' + dArr[1] + '.' + dArr[0]; // ex out: "18.01.2010"
}

/**
 * Checking if user has a role to access a page
 *
 * @return {Boolean} - whether user has a role
 * @param {String} name - role that is going to be checked
 */
export function checkRole(name: string) {
    if (localStorage.getItem('roles') === null) {
        return false;
    }
    // @ts-ignore
    return localStorage.getItem('roles').includes(name);
}

export function watchSelectedProvince(value, temp) {
    if (value !== '') {
        temp.towns = [];
        temp.municipalities = [];
        getMunicipalities(value).then((result) => {
            temp.municipalities = result;
        });
    }
}

export function watchSelectedMunicipality(value, temp) {
    if (value !== '' && value !== undefined) {
        temp.towns = [];
        getTowns(value).then((result) => {
            temp.towns = result;
        });
    }
}

